/**
 * Safely serialise a value for embedding inside an inline
 * `<script type="application/json">…</script>` tag.
 *
 * Escapes the four characters that can prematurely terminate the script
 * element or break HTML parsing, plus the two Unicode line terminators
 * that JSON allows but JavaScript does not. The output is still valid
 * JSON and round-trips through `JSON.parse`.
 */
export function escapeInlineJson(value: unknown): string {
  return JSON.stringify(value)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
}